var map = {
	"./1.mp3": [
		2940,
		2940
	],
	"./10.mp3": [
		9132,
		9132
	],
	"./11.mp3": [
		4465,
		4465
	],
	"./12.mp3": [
		9649,
		2030
	],
	"./13.mp3": [
		2323,
		2323
	],
	"./2.mp3": [
		4275,
		4275
	],
	"./3.mp3": [
		1870,
		1870
	],
	"./4.mp3": [
		5509,
		5509
	],
	"./5.mp3": [
		5232,
		5232
	],
	"./6.mp3": [
		2007,
		2007
	],
	"./7.mp3": [
		4962,
		4962
	],
	"./8.mp3": [
		5113,
		5113
	],
	"./9.mp3": [
		8100,
		8100
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6855;
module.exports = webpackAsyncContext;